@if (loadingService.isLoading()) {
  <div class="overlay">
    <div class="app-spinner" aria-hidden="true"></div>
  </div>
}
